import RadialPercent from './RadialPercent';

export default RadialPercent;

export type { IRadialPercentProps, RadialPercentSize } from './RadialPercent';
